import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  isPaymentBlocked: false,
  displayedPaymentMethods: [],
  availableComponents: [],
  isCardNumberOmnio: false,
  // Set by EvervaultErrorBoundary when the Evervault form crashes, so the
  // card form falls back to the next type (PCI iframe or default form).
  isEvervaultFailed: false,
  // Owned by useSavedCards(). Declared here so the flag is never `undefined`,
  // which used to be indistinguishable from "cards failed to load".
  areCardsLoaded: false,
  componentsLoad: {
    isConfigReady: false,
    // True only after a SUCCESSFUL transaction-details response has stored a
    // valid payment-method configuration. Unlike isConfigReady (set for every
    // outcome, incl. errors/redirects), this distinguishes a real config load.
    isConfigLoaded: false,
    isPaymentMethodsReady: false,
    isDetailsReady: false,
  },
}

const pageStateSlice = createSlice({
  name: 'pageState',
  initialState,
  reducers: {
    pageStateUpdate: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    componentsLoadUpdate: (state, { payload }) => ({
      ...state,
      componentsLoad: {
        ...state.componentsLoad,
        ...payload,
      },
    }),
  },
})

export const { pageStateUpdate, componentsLoadUpdate } = pageStateSlice.actions

export const pageStateSelector = state => state.pageState
export const isAppLoadedSelector = state =>
  state.pageState.componentsLoad.isConfigReady &&
  state.pageState.componentsLoad.isPaymentMethodsReady &&
  state.pageState.componentsLoad.isDetailsReady

export const isPaymentMethodsLoadedSelector = state => state.pageState.componentsLoad.isPaymentMethodsReady
export const isDetailsLoadedSelector = state =>
  state.pageState.componentsLoad.isDetailsReady

export default pageStateSlice.reducer
